import PAGINATION from '@sdk/helpers/misc/pagination';

import client from '@/api/client';

import crudlModuleGenerator from '@/_CRUDL/modules/generator';

export const FRR_OVERLAPPINGS_START = 'financingReturnRules/overlappings/START';
export const FRR_OVERLAPPINGS_SUCCESS = 'financingReturnRules/overlappings/SUCCESS';
export const FRR_OVERLAPPINGS_FAILURE = 'financingReturnRules/overlappings/FAILURE';

export const FRR_FIND_FOR_START = 'financingReturnRules/find_for_integrated_banks/START';
export const FRR_FIND_FOR_SUCCESS = 'financingReturnRules/find_for_integrated_banks/SUCCESS';
export const FRR_FIND_FOR_FAILURE = 'financingReturnRules/find_for_integrated_banks/FAILURE';

export const INITIAL_RETURN_FILTERS = {
  CRUDL_append: false,
  store_id: '',
  bank_id: '',
  vehicle_model_id: '',
  min_return: '',
  max_return: '',
  return_preference: '',
  quota_preference: '',
  page: 1,
  per_page: PAGINATION.MAX_PER_PAGE,
  active: false,
};

const financingReturnRules = crudlModuleGenerator('financingReturnRules', {
  customKeys: {
    list: 'financing_return_rules',
  },
  customEndpoints: {
    delete: '/financing_return_rules/:id/deactivate',
  },
  customMethods: {
    delete: 'get',
  },
});

export default {
  ...financingReturnRules,
  state: {
    ...financingReturnRules.state,
    list: {
      ...financingReturnRules.state.list,
      filters: {
        ...INITIAL_RETURN_FILTERS,
      },
    },

    overlappings: {
      loading: false,
      result: {},
      error: null,
    },

    findForIntegratedBanks: {
      loading: false,
      result: [],
      error: null,
    },
  },

  actions: {
    ...financingReturnRules.actions,

    overlappings({ commit }, payload) {
      commit(FRR_OVERLAPPINGS_START);

      return new Promise((resolve, reject) => {
        client.get('/financing_return_rules/overlappings', {
          params: {
            ...payload,
          },
        })
          .then((response) => {
            commit(FRR_OVERLAPPINGS_SUCCESS, response);

            resolve(response);
          })
          .catch((error) => {
            commit(FRR_OVERLAPPINGS_FAILURE, error);

            reject(error);
          });
      });
    },

    findForIntegratedBanks({ commit }, payload) {
      commit(FRR_FIND_FOR_START);

      return new Promise((resolve, reject) => {
        client.get('/financing_return_rules/find_for_integrated_banks', {
          params: {
            ...payload,
          },
        })
          .then((response) => {
            commit(FRR_FIND_FOR_SUCCESS, response);

            resolve(response);
          })
          .catch((error) => {
            commit(FRR_FIND_FOR_FAILURE, error);

            reject(error);
          });
      });
    },
  },

  mutations: {
    ...financingReturnRules.mutations,

    [FRR_OVERLAPPINGS_START](state) {
      state.overlappings.error = null;
      state.overlappings.result = {};
      state.overlappings.loading = true;
    },
    [FRR_OVERLAPPINGS_SUCCESS](state, response) {
      state.overlappings.error = null;
      state.overlappings.result = response.data;
      state.overlappings.loading = false;
    },
    [FRR_OVERLAPPINGS_FAILURE](state, error) {
      let details = error;

      try {
        details = error.response.data.error;
      } catch (err) { /* */ }

      state.overlappings.error = details;
      state.overlappings.result = {};
      state.overlappings.loading = false;
    },

    [FRR_FIND_FOR_START](state) {
      state.findForIntegratedBanks.error = null;
      state.findForIntegratedBanks.result = [];
      state.findForIntegratedBanks.loading = true;
    },
    [FRR_FIND_FOR_SUCCESS](state, response) {
      state.findForIntegratedBanks.error = null;
      state.findForIntegratedBanks.result = response.data.financing_return_rules;
      state.findForIntegratedBanks.loading = false;
    },
    [FRR_FIND_FOR_FAILURE](state, error) {
      let details = error;

      try {
        details = error.response.data.error;
      } catch (err) { /* */ }

      state.findForIntegratedBanks.error = details;
      state.findForIntegratedBanks.result = [];
      state.findForIntegratedBanks.loading = false;
    },
  },
};
